import { useMutation } from '@apollo/client';
import { useSelector } from 'react-redux';
import { ApolloCache, DefaultContext, DocumentNode, OperationVariables, TypedDocumentNode } from '@apollo/client/core';
import { MutationHookOptions, MutationTuple } from '@apollo/client/react/types/types';

import { getToken } from 'src/reducers/user/userSelectors';

export function useAuthorizedMutation<
  TData = any,
  TVariables = OperationVariables,
  TContext extends Record<string, any> = DefaultContext,
  TCache extends ApolloCache<any> = ApolloCache<any>
>(
  mutation: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: MutationHookOptions<TData, TVariables, Record<string, any>>
): MutationTuple<TData, TVariables, TContext, TCache> {
  const token = useSelector(getToken);

  return useMutation<TData, TVariables, TContext, TCache>(mutation, {
    ...options,
    context: {
      ...options?.context,
      headers: {
        authorization: token ? `Bearer ${token}` : '',
        ...options?.context?.headers,
      },
    } as unknown as TContext,
  });
}
